// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZdNsF","label":"styles_label__3uyqY"};